import { Button, CircularProgress, Modal } from "@material-ui/core";
import React, { memo, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PuiTypography from "../../components/elements/PuiTypography";
import { AppState } from "../../root/RootReducer";
import DirectoryList from "../../studio/components/directory/DirectoryList";
import DirectoryPath from "../../studio/components/directory/DirectoryPath";
import { GetDir, UploadFootage } from "../../studio/store/actions/DirectoryActions";
import styles from "./UploadFootageMobile.module.css";

function UploadFootageMobile() {
    // Storeからデータ取得
    const { user, directoryList, footageList, isLoadingUploadFootage } = useSelector(
        (state: AppState) => ({
            user: state.user.userInfo,
            directoryList: state.directory.directoryList,
            footageList: state.directory.footageList,
            isLoadingUploadFootage: state.timeline.isLoadingUploadFootage,
        })
    );

    const dispatch = useDispatch();

    const directoryRef = useRef<HTMLTableElement | null>(null);
    const inputFootage = useRef<HTMLInputElement>(null);

    // ModalOpenflag
    const [isOpenUploadFootageModal, ChangeIsOpenUploadFootageModal] = useState<boolean>(false);

    // 履歴用
    const [selectedHistoryPathList, setSelectedhistoryPathList] = useState<
        { id: number; name: string }[]
    >([{ id: 0, name: "メディア" }]);
    // フォルダー名リスト定義
    const [selectedPathList, setSelectedPathList] = useState<any[]>([{ id: 0, name: "メディア" }]);
    // 現在のディレクトリ
    const [currentDirectory, setCurrentDirectory] = useState<{ id: number; name: string }>({
        id: 0,
        name: "メディア",
    });

    useEffect(() => {
        if (user) {
            // ディレクトリ一覧取得APIコール
            dispatch(GetDir(0, Number(user.id)));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    // アップロードステータス状況取得
    useEffect(() => {
        let IS_UPLOADING = false;
        let timeoutId: NodeJS.Timeout;
        if (footageList && footageList.length > 0) {
            IS_UPLOADING = footageList.some((footage) => footage.status === "UPLOADING");

            if (IS_UPLOADING && user) {
                timeoutId = setTimeout(
                    () => dispatch(GetDir(currentDirectory.id, Number(user.id))),
                    5000
                );
            }
        }
        // クリーンアップ
        return () => {
            clearTimeout(timeoutId);
        };
        // eslint-disable-next-line
    }, [footageList]);

    // modal閉じる処理
    const CloseModal = () => {
        ChangeIsOpenUploadFootageModal(false);
    };

    // アップロード押下時
    const OpenModal = () => {
        ChangeIsOpenUploadFootageModal(true);
    };

    // フッテージアイテムを押下の場合、
    const handleMenufootageClick = () => {
        // フッテージを選択できるファイルエクスプローラ表示
        inputFootage.current?.click();
        // handleMenuClose();
    };

    // 拡張子なしのファイル名を設定する。
    const removeExtension = (filename: string) => {
        const lastDotPosition = filename.lastIndexOf(".");
        if (lastDotPosition === -1) return filename;
        else return filename.substring(0, lastDotPosition);
    };

    // フッテージアップロード処理
    const uploadFootage = (event: any) => {
        // 選択したフッテージファイルがある場合、
        if (event.target.files.length === 1 && !isLoadingUploadFootage) {
            if (user) {
                dispatch(
                    UploadFootage(
                        event.target.files[0],
                        removeExtension(event.target.files[0].name),
                        selectedPathList[selectedPathList.length - 1].id,
                        Number(user.id)
                    )
                );
            }
            // setShowExportSuccessMessage(true);
        }
    };

    // 作成済のフォルダーを選択した場合、
    const clickFolder = (id: number, name: string) => {
        // ディレクトリ一覧取得APIコール
        if (user) dispatch(GetDir(id, Number(user.id)));
        // 表示するディレクトリ
        setCurrentDirectory({ id, name });
        // rootからディレクトリが変わったかの判断
        const isDirectory = selectedHistoryPathList.some((path) => {
            return path.id === id;
        });
        //履歴用の配列
        let tempSelectHistoryPathList: any[] = [];
        if (selectedPathList.length === 1 && !isDirectory && selectedHistoryPathList.length > 1) {
            tempSelectHistoryPathList = [{ id: 0, name: "メディア" }];
        } else {
            tempSelectHistoryPathList = selectedHistoryPathList;
        }
        tempSelectHistoryPathList.push({
            id: id,
            name: name,
        });
        // 履歴用の配列に保存
        setSelectedhistoryPathList(tempSelectHistoryPathList);

        // 選択したフォルダーID・フォルダー名を配列に保存
        setSelectedPathList([
            ...selectedPathList,
            {
                id: id,
                name: name,
            },
        ]);
        if (!directoryRef || !directoryRef.current) return;
        directoryRef.current.scrollTop = 0;
    };

    return (
        <>
            <div onClick={OpenModal} className={styles.upload}>
                cineonstudioへアップロード
            </div>
            <Modal
                open={isOpenUploadFootageModal}
                onClose={CloseModal}
                className={styles.uploadFootageModal}
            >
                <div className={styles.root}>
                    <div onClick={CloseModal} className={styles.closeButton}>
                        <img src={require("../../assets/image/closeFilter.svg")} alt="close" />
                    </div>
                    {/* フォルダー名表示 */}
                    <div className={styles.header}>
                        <DirectoryPath
                            selectedHistoryPathList={selectedHistoryPathList}
                            setSelectedhistoryPathList={setSelectedhistoryPathList}
                            directoryList={directoryList}
                            selectedPathList={selectedPathList}
                            setSelectedPathList={setSelectedPathList}
                            setCurrentDirectory={setCurrentDirectory}
                            currentDirectory={currentDirectory}
                            directoryRef={directoryRef}
                        />
                        {/* フッテージ作成メニュー表示 */}
                        <Button
                            onClick={handleMenufootageClick}
                            className={styles.footageBtn}
                            disabled={selectedPathList.length === 1}
                            style={{
                                opacity: selectedPathList.length === 1 ? "0.2" : 1,
                            }}
                        >
                            <div className={styles.footageUploadBtn} />
                        </Button>
                        {/* フッテージアップロード用 */}
                        <input
                            type="file"
                            accept="video/*"
                            style={{ display: "none" }}
                            ref={inputFootage}
                            onChange={uploadFootage}
                        />
                    </div>
                    <DirectoryList
                        directoryList={directoryList}
                        footageList={footageList}
                        clickFolder={clickFolder}
                        directoryRef={directoryRef}
                    />
                </div>
            </Modal>
            {/* フッテージアップロードモーダル表示 */}
            <Modal open={isLoadingUploadFootage}>
                <div className={styles.noContent}>
                    <CircularProgress
                        size={60}
                        style={{ color: "var(--loading-bg)", marginBottom: "15px" }}
                    />
                    <div className={styles.text}>
                        <PuiTypography>{"アップロード中です・・・"}</PuiTypography>
                    </div>
                </div>
            </Modal>
        </>
    );
}
export default memo(UploadFootageMobile);
